import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard'
import { LoginComponent } from './core/login/login.component'
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component'
import { HomeComponent } from './shared/home/home.component'

const ucetniJednotkaModule = () => import('../app/ucetni-jednotka/ucetni-jednotka.module').then(x => x.UcetniJednotkaModule);
const userModule = () => import('../app/user/user.module').then(x => x.UserModule);
const roleModule = () => import('../app/role/role.module').then(x => x.RoleModule);
const croRegistrationModule = () => import('../app/cro-registration/cro-registration.module').then(x => x.CroRegistrationModule);
const prenosUcetniJednotkaModule = () => import('../app/prenos-ucetni-jednotka/prenos-ucetni-jednotka.module').then(x => x.PrenosUcetniJednotkaModule);
const cleneniProVykazyModule = () => import('../app/cleneni-pro-vykazy/cleneni-pro-vykazy.module').then(x => x.CleneniProVykazyModule);
const kontaceModule = () => import('../app/kontace/kontace-module').then(x => x.KontaceModule);
const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'ucetni-jednotky',
        loadChildren: ucetniJednotkaModule
      },
      {
        path: 'uzivatele',
        loadChildren: userModule
      },
      {
        path: 'role',
        loadChildren: roleModule
      },
      {
        path: 'cro-registrace',
        loadChildren: croRegistrationModule
      },
      {
        path: 'prenos-ucetni-jednotky',
        loadChildren: prenosUcetniJednotkaModule
      },
      {
        path: 'cleneni-pro-vykazy',
        loadChildren: cleneniProVykazyModule
      },
      {
        path: 'kontace',
        loadChildren: kontaceModule
      }
    ]
  },
  {
    path: 'account/login',
    component: LoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
